import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "list",
        "target",
        "zoneRow",
        "itemTitle",
        "arrow"
    ]

    static values = {
        expanded: { type: Boolean, default: false }
    }

    toggle(event) {
        this.expandedValue = !this.expandedValue;
    }

    closeOnOutsideClick(event) {
        if (this.element.contains(event.target)) return;
        this.expandedValue = false;
    }

    handleCheckboxSelect(event) {
        let totalSelected = 0
        this.zoneRowTargets.forEach((row) => {
            if (row.checked) totalSelected += 1
        })
        if (totalSelected > 0) {
            this.updateItemTitle(totalSelected);
        } else {
            this.resetItemTitle()
        }
    }

    updateItemTitle(totalSelected) {
        const newTitle = `${totalSelected} ${totalSelected > 1 ? "zones" : "zone"} selected`
        this.itemTitleTarget.innerHTML = newTitle
    }

    resetItemTitle() {
        const newTitle = "All Zones"
        this.itemTitleTarget.innerHTML = newTitle
    }

    expandedValueChanged(isExpanded) {
        if (!this.hasListTarget) return;

        if (isExpanded) {
        this.listTarget.style.transition = "height 0.06s ease-in-out";

        const height = this.listTarget.scrollHeight;
        this.listTarget.style.height = `${height}px`;

        const onEnd = () => {
            this.listTarget.removeEventListener("transitionend", onEnd);
            if (this.expandedValue) {
            this.listTarget.style.height = "auto";
            }
        };
        this.listTarget.addEventListener("transitionend", onEnd);

        if (this.hasArrowTarget) this.arrowTarget.style.transform = "rotate(0deg)";
        } else {
        if (this.listTarget.style.height === "auto") {
            this.listTarget.style.transition = "none";
            this.listTarget.style.height = `${this.listTarget.scrollHeight}px`;
            this.listTarget.offsetHeight;
        }

        this.listTarget.style.transition = "height 0.2s";
        this.listTarget.style.height = "0px";
        if (this.hasArrowTarget) this.arrowTarget.style.transform = "rotate(180deg)";
        }
  }
}
